import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import {
  faInstagram,
  faFacebook,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";

const Section = styled.section`
  padding: 100px 0;

  @media (max-width: 768px) {
    padding: 70px 0;
  }
`;

const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const SectionTitle = styled.h2`
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 20px;
  color: #1a5f7a;

  @media (max-width: 576px) {
    font-size: 2rem;
  }
`;

const SectionSubtitle = styled.p`
  text-align: center;
  max-width: 700px;
  margin: 0 auto 60px;
`;

const ContactDetails = styled.div`
  text-align: center;
`;

const ContactInfo = styled.div`
  display: inline-flex;
  align-items: center;
  margin: 10px 0;
`;

const ContactIcon = styled.span`
  margin-right: 10px;
  color: #1a5f7a;
`;

const SocialIcons = styled.div`
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: 30px;
`;

const SocialIcon = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(26, 95, 122, 0.1);
  color: #1a5f7a;
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    background-color: #1a5f7a;
    color: white;
    transform: translateY(-3px);
  }
`;

const ContactSection = () => {
  return (
    <Section id="contact">
      <Container>
        <SectionTitle>Contact Us</SectionTitle>
        <SectionSubtitle>
          Get in touch with our team for more information
        </SectionSubtitle>

        <ContactDetails>
          <ContactInfo>
            <ContactIcon>
              <FontAwesomeIcon icon={faPhone} />
            </ContactIcon>
            <span>+92-303-0312222</span>
          </ContactInfo>
          <br />
          <ContactInfo>
            <ContactIcon>
              <FontAwesomeIcon icon={faEnvelope} />
            </ContactIcon>
            <span>terraceskyline1@gmail.com</span>
          </ContactInfo>
          <SocialIcons>
            <SocialIcon
              href="https://www.instagram.com/skylineterracegaliyat?igsh=anVrd2Y0cXJrYjg3"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faInstagram} />
            </SocialIcon>
            <SocialIcon
              href="https://www.facebook.com/profile.php?id=61575225360796&mibextid=ZbWKwL"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faFacebook} />
            </SocialIcon>
            <SocialIcon
              href="https://wa.me/+923030312222"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faWhatsapp} />
            </SocialIcon>
          </SocialIcons>
        </ContactDetails>
      </Container>
    </Section>
  );
};

export default ContactSection;
